module.exports = __webpack_public_path__ + "img/about-photo2.0eb912b4.jpg";